module.exports = __webpack_public_path__ + "img/google.ea3bac4c.png";